module.exports = __webpack_public_path__ + "img/Digi_entwurf_5.452f2f46.png";